<template>
	<div class="testPaper">


		<el-input v-model="key" class="h-[58px] text-[16px] mb-[10px]" @change="change"
			:placeholder="langInfo.study_keywords_search"></el-input>

		<div class="" v-if="isFinish&&subjectList.length>0">

			<div style="min-height: 500px;">
				<div :class="item.is_expired==1?'bg-[#e7e9eb]':''" v-for="(item,index) in subjectList" :key="index"
					class="no-underline py-[20px] px-[16px] box-border  bB-03  mb-[12px] ">
					<div class="rounded-[5px]   flex items-center justify-between">
						<div class="flex-1 flex">
							<el-image class="w-[147px] h-[112px] mr-[14px] rounded-[6px]"
								:src="item.courseSubject.image" fit="cover"></el-image>
							<div class=" h-[112px]  flex-1 flex flex-col justify-between">
								<div class="">
									<div
										class="text-[16px] text-[#000000]  mb-[10px] flex items-center justify-between">
										<div class="yw-text-cut-1">
											{{item.courseSubject.name}}
										</div>
										<div @click="subjectInfoClick(item,index)"
											class="w-[200px] cursor-pointer text-right text-[#2979FF] text-[12px] ml-[20px]">
											{{langInfo.study_subject_view}}>>
										</div>
									</div>

									<div class="flex items-center mb-[10px] text-[12px]">
										<div class="flex items-center min-w-[90px] mr-[10px]">
											<img src="@/static/image/icon35.png" class="w-[15px] h-[15px] mr-[10px]" />
											<div class="  text-[#A2A2A2]">
												{{langInfo.study_exam_title}}
											</div>
										</div>
										<div class="flex-1  text-[#0F1419]">
											{{langInfo.study_exam_duration}}{{item.courseSubject.exam_duration}}min；{{langInfo.study_exam_total}}{{item.courseSubject.total_score}}；{{langInfo.study_exam_pass}}{{item.courseSubject.qualified_score_line}}
											<!-- <label class="cursor-pointer text-[#2979FF] ml-[20px]"
											@click="examInfoClick(item,index)">{{langInfo.exam_infor_details}}>></label> -->
										</div>
									</div>
									<div class="flex items-center mb-[8px] text-[12px] text-[#FF0000]">
										{{langInfo.validity_period}}:{{item.expiration_date}}
									</div>
									<div class="text-[#FF0000] text-[12px] mt-[5px]" v-if="item.is_expired==1">
										{{langInfo.study_subject_overdue}}
									</div>
								</div>
								<div class="flex justify-end">
									<!-- <div @click="showClick(item,index)" v-if="item.is_expired!=1&& item.isShow"
									class="bg-white cursor-pointer text-[14px] text-[#101010] text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px] border border-[#bbbbbb] border-solid">
									{{langInfo.auto_exam}}
								</div> -->
								</div>
							</div>
						</div>
						<div class="flex items-center cursor-pointer text-[#FF0000] text-[14px]"
							@click="showClick(item,index)">
							<label v-if="item.isShow" class=" mr-[2px] cursor-pointer">点击收起</label>
							<label v-else-if="!item.isShow" class=" mr-[2px] cursor-pointer">点击展开</label>
							<img v-if="item.isShow" src="@/static/image/icon32.png"
								class="w-[24px] h-[24px] cursor-pointer" />
							<img v-else-if="!item.isShow" src="@/static/image/icon33.png"
								class="w-[24px] h-[24px] cursor-pointer" />
						</div>
					</div>

					<div v-if="item.isShow" class="border-02 rounded-[5px] mt-[20px] text-[14px] text-[#101010]">
						<div class="flex items-center bg-[#E2E2E2] ">
							<div @click.shop="selectTestMethod(1,item,index)" :class="item.testMethod==1?'bg-white':''"
								class=" h-[36px] px-[30px] box-border cursor-pointer leading-[36px] text-center ">
								{{langInfo.study_exam_system}}
							</div>
							<div @click.shop="selectTestMethod(2,item,index)" :class="item.testMethod==2?'bg-white':''"
								class="px-[30px] box-border h-[36px] cursor-pointer leading-[36px] text-center">
								{{langInfo.study_exam_auto}}
							</div>
						</div>
						<div class="py-[16px] px-[23px] box-border">
							<div v-if="item.testMethod==1"
								class="title relative mb-[12px] pl-[20px] box-border text-[16px] text-[#FF0000]  font-bold">
								{{langInfo.study_exam_system}}
							</div>
							<div v-else-if="item.testMethod==2"
								class="title relative flex items-center justify-between mb-[12px]  pl-[20px] box-border text-[16px] text-[#FF0000]  font-bold">
								<div class="flex items-center flex-1 mr-[10px]">
									<label class="min-w-[80px] whitespace-nowrap">{{langInfo.study_exam_auto}}</label>
									<label
										class="text-[12px] flex-1 text-[#A3A3A3] ml-[20px]">{{langInfo.study_exam_auto_remark}}
									</label>
								</div>
								<div @click.stop="autoGenerateClick(item,index)"
									class="min-w-[100px] px-[12px] box-border h-[30px]  leading-[30px] cursor-pointer border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
									{{langInfo.study_exam_auto_submit}}
								</div>
							</div>
							<!-- // type=类型:1=自由组卷,2=模拟考(后台组卷),3章节练习 -->
							<div class="" v-if="item.isFinish&&item.paperList.length>0">
								<div class="mb-[20px]" v-for="(itm,ind) in item.paperList" :key="ind">
									<div
										class=" bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
										<div> <label v-if="item.testMethod==1">【{{langInfo.study_exam_system}}】</label>
											<label v-else-if="item.testMethod==2">【{{langInfo.study_exam_auto}}】</label>
											{{itm.title}}
										</div>

										<div class="flex items-center">
											<router-link v-if="itm.is_question==1"
												:to="{path:'/exam/examTip',query:{order_item_id:item.id,testMethod:item.testMethod,id:itm.id}}"
												class="px-[10px] box-border whitespace-nowrap h-[30px] no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
												{{langInfo.study_exam_start}}
											</router-link>
											<router-link v-else-if="itm.is_question==2"
												:to="{path:'/exam/examQuestions',query:{order_item_id:item.id,id:itm.is_exam_list.question_paper_id,identification:itm.is_exam_list.identification}}"
												class="px-[10px] box-border whitespace-nowrap h-[30px] no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
												{{langInfo.study_exam_continue}}
											</router-link>
											<i @click.stop="showExamClick(itm,ind)"
												:class="itm.isShow?'el-icon-arrow-down':'el-icon-arrow-right'"
												class="cursor-pointer ml-[10px] text-[18px]"></i>
										</div>
									</div>

									<div class="px-[32px] box-border" v-if="itm.isShow&&itm.exam_list.length>0">
										<div v-for="(ts,isIndex) in itm.exam_list" :key="isIndex"
											class=" py-[20px] box-border leading-[20px] bB-01">
											<div class="" v-if="ts.status=='complete'">
												【{{langInfo.study_exam_time}}】:{{ts.start_time}},
												【{{langInfo.study_exam_status}}】:<label
													v-if="ts.status=='pending'">{{langInfo.examing}}</label>
												<label v-else-if="ts.status=='tentative'">{{langInfo.pausing}}</label>
												<label v-else-if="ts.status=='in_progress'">{{langInfo.examing}}</label>
												<label
													v-else-if="ts.status=='complete'">{{langInfo.study_paper_over}}</label>,
												【{{langInfo.study_exam_system_duration}}】:{{ts.exam_duration}}{{langInfo.study_test_remark1_1}},
												【{{langInfo.study_exam_actual_duration}}】:{{ts.TIME}}{{langInfo.study_test_remark1_1}},
												【{{langInfo.study_exam_wrong_total}}】:{{ts.wrong_count}}/ {{ts.count}},
												【{{langInfo.study_exam_result_total}}】:{{ts.score}}/
												{{itm.total_score}},
												【{{langInfo.study_exam_result}}】:<label
													v-if="ts.result=='fail'">{{langInfo.not_pass}} </label>
												<label v-else-if="ts.result=='fail'">{{langInfo.passed}} </label>
												<label @click="goExamAnalysis(ts,ind)"
													class="text-[12px] text-[#0080FF] cursor-pointer ml-[16px]">{{langInfo.study_exam_record}}>></label>
											</div>
										</div>
									</div>
									<div v-else-if="itm.isShow&&itm.exam_list.length==0"
										class="pt-[18px] box-border text-center">
										{{langInfo.no_exam_info}}
									</div>
								</div>
							</div>
							<emptyPage v-else-if="item.isFinish&&item.paperList.length==0"
								:title="langInfo.no_test_paper_infor">
							</emptyPage>
						</div>
					</div>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>

		<emptyPage v-else-if="isFinish&&subjectList.length==0" :title="langInfo.no_chapter_records"></emptyPage>

		<!-- 科目介绍 -->
		<el-dialog :title="langInfo.study_subject_title" :visible.sync="subjectVisible" :close-on-click-modal="false"
			width="50%" center>
			<div class="max-h-[50vh] overflow-y-scroll" v-html="subjectBlurb">
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="subjectVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="subjectVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 科目介绍 -->
		<!-- 考试信息 -->
		<el-dialog :title="langInfo.exam_infor_details" :visible.sync="examVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="mb-[6px]">
					{{langInfo.study_exam_duration}}:{{courseSubject.exam_duration}}min
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_total}}:{{courseSubject.total_score}}
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_pass}}:{{courseSubject.qualified_score_line}}
				</div>
				<div class="mb-[6px]" v-if="courseSubject.count">
					{{langInfo.questions_number}}:{{courseSubject.count}}
				</div>
				<div class="" v-if="courseSubject.score">
					{{langInfo.single_question_score}}:{{courseSubject.score}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="examVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 考试信息 -->
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		name: "testPaper",
		components: {
			emptyPage
		},
		data() {
			return {
				testMethod: 2, //1后台组卷  2 自动生成
				key: '',
				// 科目
				page: 1,
				limit: 6,
				total: 0,
				subjectList: [],
				isFinish: false,

				subjectVisible: false, //科目介绍
				subjectBlurb: '',
				examVisible: false, //考试信息
				courseSubject: {},
				langInfo: {}
			}
		},
		mounted() {

			this.getMyPapersWithSubject()

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title = this.langInfo.study_my_exam
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_exam
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			change(e) {
				console.log(e);
				this.key = e
				this.page = 1;
				this.total = 0
				this.isFinish = false

				this.getMyPapersWithSubject()
			},
			currentChange(e) {
				this.page = e
				this.isFinish = false
				this.getMyPapersWithSubject()
			},
			getMyPapersWithSubject() {
				this.$api.getMyPapersWithSubject({
					page: this.page,
					pageSize: this.limit,
					key: this.key,
					is_subject_list: '1,4'
				}).then((res) => {
					console.log(res);
					this.subjectList = res.data.data

					this.subjectList.forEach((item, index) => {
						this.$set(item, 'isShow', false)
						this.$set(item, 'testMethod', 1)
						this.$set(item, 'isFinish', false)
						this.$set(item, 'paperList', [])
					})
					console.log("this.subjectList===");
					console.log(this.subjectList);
					this.total = res.data.total
					this.isFinish = true
				}).catch((error) => {
					console.log("error.code====" + error.code);
					this.isFinish = true
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			subjectInfoClick(item, index) {
				this.subjectBlurb = item.courseSubject.blurb
				this.subjectVisible = true
			},
			examInfoClick(item, index) {
				this.courseSubject = item.courseSubject
				this.examVisible = true
			},
			showClick(item, index) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				this.subjectList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isShow = !itm.isShow
						if (itm.isShow) {
							itm.isFinish = false
							this.getQuestList(itm, 2, index)
						}
					} else {
						itm.isShow = false
					}
				})
			},

			selectTestMethod(type, item, index) {
				item.testMethod = type
				item.isFinish = false

				if (type == 1) {
					this.getQuestList(item, 2, index)
				} else if (type == 2) {
					this.getQuestList(item, 1, index)
				}

			},
			getQuestList(item, type, index) {

				// type=类型:1=自由组卷,2=模拟考(后台组卷),3章节练习
				this.$api.question_list({
					type: type,
					course_subject_id: item.course_subject_id,
					order_item_id: item.id
				}).then((res) => {
					console.log(res.data);
					this.subjectList[index].paperList = res.data

					item.isFinish = true

					res.data.forEach((item, index) => {
						this.$set(item, 'isShow', false)
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			showExamClick(itm, ind) {
				itm.isShow = !itm.isShow
			},
			// 查看解析
			goExamAnalysis(item, index) {
				this.$router.push({
					path: '/exam/examAnalysis',
					query: {
						id: item.question_paper_id,
						identification: item.identification,
						viewMethod: 'read'
					}
				})
			},
			// 点此自动组卷
			autoGenerateClick(item, index) {
				var that = this
				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
				}).then((res) => {
					console.log(res.data.code == 1);
					if (res.data.code == 1) {
						item.isFinish = false
						this.getQuestList(item, 1, index)
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else if (res.data.code == 0) {
						this.$confirm(this.langInfo.is_cleared_exercises_record, this.langInfo.reg_tip, {
							confirmButtonText: this.langInfo.clear_tip,
							cancelButtonText: this.langInfo.no_clear,
							type: 'info'
						}).then((ms) => {
							console.log(ms);
							if (ms == "confirm") {
								that.$api.clear_exam_record({
									course_subject_id: item.course_subject_id
								}).then((res) => {
									console.log(res);
									that.reStart(item, index)
								}).catch((error) => {
									that.$message({
										message: error.msg,
										type: 'warning'
									})
								})
							}
						}).catch(() => {
							that.randomPaper(item, index)
						});
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
			// 随机生成
			randomPaper(item, index) {
				var that = this
				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
					is_sj: 0,
				}).then((res) => {
					item.isFinish = false
					this.getQuestList(item, 1, index)
					this.$message({
						message: res.msg,
						type: 'success'
					})
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
			reStart(item, index) {
				var that = this
				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
				}).then((res) => {
					item.isFinish = false
					this.getQuestList(item, 1, index)
					this.$message({
						message: res.msg,
						type: 'success'
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
		}
	}
</script>

<style scoped>
	/deep/.el-input__inner::placeholder {
		color: #888888;
	}

	/deep/.el-input__inner {
		height: 100%;
		border-color: #BBBBBB;
	}


	.title::after {
		content: '';
		position: absolute;
		width: 3px;
		height: 14px;
		background-color: rgba(255, 0, 0, 1);
		top: 50%;
		left: 0;
		transform: translateY(-50%);
	}
</style>